import ApiService from './ApiService';

const apiService = new ApiService();

export default apiService;
